import { apiFetch } from './client';
import { mapAnalyticsError, toApiChannel } from './analyticsParams';
import {
  mockCreateReport,
  mockDownloadUrl,
  mockGetReport,
  mockListReports,
  mockTemplates,
} from '../pages/Analytics/mockData';

const USE_MOCK = process.env.REACT_APP_ANALYTICS_MOCK === '1';

function qs(params) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') sp.set(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
}

async function withMock(request, mockFn) {
  if (USE_MOCK) return mockFn();
  return request();
}

export const REPORT_ERRORS = {
  unauthorized: 'Sign in again to continue.',
  not_found: 'Report not found.',
  not_ready: 'Report is not ready yet. Try again in a moment.',
  forbidden: 'You do not have permission to run this report.',
  range_too_long: 'That date range is too long for reports (max 366 days).',
};

/** @deprecated Prefer toApiChannel from analyticsParams — kept for existing imports. */
export function toReportChannel(channel) {
  return toApiChannel(channel);
}

/** Build POST /store/reports body per API contract (`type`, uppercase channel). */
export function toCreateReportBody({ type, from, to, channel, format }) {
  return {
    type,
    from,
    to,
    channel: toApiChannel(channel),
    format: String(format || 'csv').toLowerCase(),
  };
}

export function listReportTemplates(token, { isAdmin = true } = {}) {
  return withMock(
    () => apiFetch('/store/reports/templates', { token }),
    () => mockTemplates(isAdmin)
  );
}

export function listReports({ limit = 20 } = {}, token) {
  return withMock(
    () => apiFetch(`/store/reports${qs({ limit })}`, { token }),
    () => mockListReports()
  );
}

/** Single-job status: GET /store/reports/{id} */
export function getReport(id, token) {
  return withMock(
    () => apiFetch(`/store/reports/${encodeURIComponent(id)}`, { token }),
    () => mockGetReport(id)
  );
}

export function createReport(body, token) {
  const payload = toCreateReportBody(body);
  return withMock(
    () => apiFetch('/store/reports', { method: 'POST', token, body: payload }),
    () =>
      mockCreateReport({
        type: payload.type,
        from: payload.from,
        to: payload.to,
        channel: payload.channel,
        format: payload.format,
      })
  );
}

export function getReportDownload(id, token) {
  return withMock(
    () => apiFetch(`/store/reports/${encodeURIComponent(id)}/download`, { token }),
    () => mockDownloadUrl(id)
  );
}

export { mapAnalyticsError };
